"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.delay = exports.LogLevel = void 0;
exports.formatTime = formatTime;
exports.getBaseFilename = getBaseFilename;
exports.getFilename = getFilename;
exports.trueAssign = trueAssign;
exports.formatLine = formatLine;
var LogLevel;
(function (LogLevel) {
    LogLevel["Critical"] = "Critical";
    LogLevel["Error"] = "Error";
    LogLevel["Warn"] = "Warn";
    LogLevel["Info"] = "Info";
    LogLevel["Debug"] = "Debug";
})(LogLevel || (exports.LogLevel = LogLevel = {}));
function formatTime(date) {
    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");
    const milliseconds = date.getMilliseconds().toString().padEnd(3, "0");
    return `[${hours}:${minutes}:${seconds}.${milliseconds}]`;
}
function getBaseFilename(date) {
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
}
function getFilename(date, part) {
    if (typeof date === "string")
        return `${date}(${part}).log`;
    return `${getBaseFilename(date)}(${part}).log`;
}
// assign<T extends {}, U>(target: T, source: U): T & U
function trueAssign(target, source) {
    if (!source)
        return target;
    for (const key in source) {
        if (source[key] != null) {
            target[key] = source[key];
        }
    }
    return target;
}
function formatLine(date, tag, level, args) {
    return `${formatTime(new Date(date))} [${level}:${tag}] ${args.map((arg) => toString(arg))}\n`;
}
function toString(arg) {
    const type = typeof arg;
    switch (type) {
        case "bigint":
        case "boolean":
        case "number":
            return arg.toString();
        case "string":
            return arg;
        case "function":
            return arg.name;
        case "object":
            try {
                return JSON.stringify(arg);
            }
            catch {
                return arg.toString();
            }
        case "symbol":
        case "undefined":
        default:
            return type;
    }
}
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
exports.delay = delay;
